export default __webpack_public_path__ + "static/media/hazz.73b33681.png";